/**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

// TIMELINE
const elTimelineContent = el.querySelector('.content');
const elYearMarker      = el.querySelector('.marker');
const elBtnYear         = Array.from(el.querySelectorAll('.btn-year'));
const yearHistory       = Array.from(el.querySelectorAll('.year-history'));

const setMarkerTop = el => {
    const btnYearHeight = parseFloat(getComputedStyle(elBtnYear[0], null).height.replace('px', '') / 2);
    const timelineTop   = elTimelineContent.getBoundingClientRect().top;
    const btnTop        = el.getBoundingClientRect().top;
    const yearMarkerTop = btnTop - timelineTop + btnYearHeight;

    elYearMarker.style.top = `${yearMarkerTop}px`;
}

// Click to Active and marker reposition
elBtnYear.forEach(el => el.onclick = function () {
    const contentActive = document.querySelectorAll('.year-history.active');
    const contentShow = el.nextElementSibling;

    if (wW < 768) {
        if (!el.classList.contains('active')) {
            TweenLite.to(contentActive, .4, {height:0});

            TweenLite.set(contentShow, {height:"auto"});
            TweenLite.from(contentShow, .4, {height:0, onComplete: function(){
                Navigation.helpers.scrollTo($(el));
            }});
        }
    }

    elBtnYear.forEach(el => el.classList.remove('active'));
    this.classList.add('active');

    (wW > 767) && setMarkerTop(el);

    contentActive.forEach(el => el.classList.remove('active'));
    contentShow.classList.add('active');
});

// Arrow navigation
const arrowNavigation = () => {
    const elTimeline = el.querySelector('.timeline');
    const triggerClick = document.createEvent('HTMLEvents');
    triggerClick.initEvent('click', true, false);

    document.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' || !elTimeline.matches(':hover')) return;

        const activeElement = elTimelineContent.querySelector('.active');

        const el = (e.key === 'ArrowLeft')
            ? activeElement.previousElementSibling.previousElementSibling
            : activeElement.nextElementSibling.nextElementSibling;

        el && el.dispatchEvent(triggerClick);
    });
}

(wW > 767) && arrowNavigation();

window.onresize = function() {
    if (wW > 767) {
        document.querySelectorAll('.year-history').forEach(el => el.removeAttribute('style'));
    }
}
